<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px"
    class="app-container view-container">
    <BjDivider>
      {{ $t('BusinessPurchaseApply.dataForm.title') }}
      <template #right>
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
      </template>
    </BjDivider>
    <template>
      <el-row :gutter="10">
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.code')" prop="code">
            <BjInput v-model="form.purchaseCode" disabled :placeholder="$t('BusinessPurchaseComponentsPur.automatic')"
              :maxlength="MAX_LENGTH.DEFAULT" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.supplierCode')" prop="supplierCode">
            <BjSelectSupplier v-model="form.supplierCode" option-value="code" :page-size="100" :default-options="{
              label: form.supplierName,
              value: form.supplierCode,
            }" :disabled="isEdit" @change="onChangeSupplier" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.type')" :disabled="isEdit" prop="purchaseType">
            <BjSelectLov v-model="form.purchaseType" :disabled="isEdit" :option-list="PURCHASE_TYPE"
              @change="changeLov" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.warehouseCode')" prop="warehouseCode">
            <BjSelectWarehouse v-model="form.warehouseCode" value-code="code" :type-code="['logic']"
              @change="onChangeWarehouse" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item v-if="isEdit" :label="$t('BusinessPurchaseComponentsPur.buyerName')" prop="buyerName">
            <BjInput v-model="form.createdName" :maxlength="MAX_LENGTH.DEFAULT" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseApply.isFill')">
            <BjSelectLov v-model="form.isFill" :option-list="STATUS_YES_NUM" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.postingDate')" prop="postingDate">
            <BjDatePicker v-model="form.postingDate" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.documentDate')" prop="documentDate">
            <BjDatePicker v-model="form.documentDate" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.remark')" prop="remark">
            <BjInput v-model="form.remarks" autosize type="textarea" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <div class="bj-row mt20">
      <BjDivider>
        {{ $t('BusinessPurchaseComponentsPur.information') }}
        <template>
          <el-button v-if="list.length === 0" type="primary" @click="onAdd">{{
            $t('BusinessPurchaseComponentsPur.addingGoods') }}</el-button>
          <el-button v-if="form.purchaseType !== 'COMMON'" type="primary" @click="onImport">{{
            $t('EXCELImportText') }}</el-button>
          <el-button :disabled="selection.length === 0" @click="onDelete()">{{ $t('delText') }}</el-button>
        </template>
        <template #right>
          <RightToolbar
            @showSetting="toolbarShow"
          />
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table v-if="tableShow" :data="form.goodsList" border script max-height="600px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="70" align="center" fixed="left" />
          <el-table-column prop="skuCode" label="SKU" align="center" fixed="left" width="133" />
          <el-table-column :label="$t('BusinessPurchaseApplyDetail.orderQty') +' (a)'" prop="planQty" align="center" width="140">
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.planQty" :min="0" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column v-if="$route.query.source==='forecast'" :label="$t('BusinessPurchaseApply.planQty') + ' (b)'" prop="alreadyQty" align="center" width="150">
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.cnPurchasePrice') + ' (c)'" prop="cnPurchasePrice" align="center" width="120">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.cnPurchasePrice" :min="0" class="full-width" :controls="false" :clearable="false" />
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.auPurchasePrice" :label="$t('BusinessPurchaseDetailPage.table.Australian')+' (d)'" prop="auPurchasePrice" align="center" width="170">
            <el-table-column prop="auPurchasePrice" align="center"
              :label="`d = c * 1.02 / ${(exchangeRate.aud).toFixed(2)}`" width="170">
              <template v-slot="{ row }">
                {{ row.auPurchasePrice }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.price') + ' (e)'" prop="price" align="center" width="130">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.price" :min="0" class="full-width" :clearable="false" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.linkUrl" :label="$t('BusinessPurchaseDetailPage.table.Link')" prop="linkUrl" align="center" width="140">
            <template v-slot="{ row }">
              <BjInput v-model="row.linkUrl" :placeholder="$t('inputText')" :min="0" class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Price')" prop="linkMinPrice" align="center" width="140">
            <template v-slot="{ row }">
              <BjInput v-model="row.linkMinPrice" :placeholder="$t('inputText')" :min="0" clearable class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Express')+' (f)'" prop="expressPrice" align="center" width="140">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.expressPrice" :min="0" class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.consumptionTax" :label="$t('BusinessPurchaseDetailPage.table.Consumption')+' (g)'" prop="consumptionTax" align="center" width="155">
            <el-table-column prop="consumptionTax" align="center" :label="consumptionTaxHead" width="155">
              <template v-slot="{ row }">
                {{ row.consumptionTax }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="form.purchaseType !== 'COMMON' && sortableSetting.platformPrice" :label="$t('BusinessPurchaseDetailPage.table.Platform')+' (h)'" prop="platformPrice" align="center" width="140">
            <el-table-column prop="platformPrice" align="center" :label="platformPriceHead" width="140">
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="sortableSetting.taxCode" prop="taxCode" :label="$t('BusinessPurchaseComponentsPur.table.TaxCode')" align="center" width="100">
              <template slot-scope="{ row }">
                <el-select v-model="row.taxCode">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          <el-table-column v-if="sortableSetting.refundResendPrice" label="return+resend (j)" align="center" width="140">
            <el-table-column align="center" prop="refundResendPrice" :label="resendRefundRateHead" width="140">
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.usdFreight') + ' (k)'" prop="usdFreight" align="center" width="118">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.usdFreight" :min="0" class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.cnyFreight') + ' (l)'" prop="cnyFreight" align="center" width="120">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.cnyFreight" :min="0" class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.handlePrice') + ' (m)'" prop="handlePrice" align="center" width="120">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.handlePrice" :min="0" class="full-width" :controls="false" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessPurchaseApply.cabinetVolume') + ' (n)'" prop="cabinetVolume" align="center" width="140">
            <template v-slot="{ row }">
              <BjInputMoney v-model="row.cabinetVolume" :min="0" class="full-width" :controls="false">
                <template slot="append">m³</template>
              </BjInputMoney>
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.seaInlandFreight" :label="$t('BusinessPurchaseApply.seaInlandFreight') + ' (o)'" prop="seaInlandFreight" align="center" width="290">
            <el-table-column align="center" prop="seaInlandFreight" :label="seaAndInlandFreightHead" width="290">
              <template v-slot="{ row }">
                {{ row.seaInlandFreight !== 'NaN' ? row.seaInlandFreight : '' }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="sortableSetting.ebayPaypalPrice" :label="$t('BusinessPurchaseApply.ebayPaypalPrice') + ' (p)'" align="center" width="150">
            <el-table-column align="center" prop="ebayPaypalPrice" :label="ebayAndPaypalHead" width="150">
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="sortableSetting.estimatedProfit" :label="$t('BusinessPurchaseDetailPage.table.Estimated')+' (q)'" prop="estimatedProfit" align="center" width="160">
            <el-table-column prop="estimatedProfit" align="center" :label="estimatedProfitHead" width="160">
              <template v-slot="{ row }">
                {{ row.estimatedProfit !== 'NaN' ? row.estimatedProfit : '' }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="sortableSetting.estimatedProfitRate" :label="$t('BusinessPurchaseDetailPage.table.Expected')+' (r)'" prop="estimatedProfitRate" align="center" width="130">
            <template v-slot="{ row }">
              {{ row.estimatedProfitRate !== 'NaN' ? row.estimatedProfitRate : '' }}%
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.requiredDate" prop="requiredDate" :label="$t('BusinessPurchaseComponentsPur.requiredDate')" align="center" width="156">
            <template v-slot="{ row }">
              <BjDatePicker v-model="row.requiredDate" />
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" prop="barCode" align="center" width="120" />
          <el-table-column v-if="sortableSetting.brandName" :label="$t('BusinessPurchaseDetailPage.table.brand')" prop="brandName" align="center" width="120" />
          <el-table-column v-if="sortableSetting.categoryName" :label="$t('BusinessPurchaseDetailPage.table.Product1')" prop="categoryName" align="center" width="145" />
          <el-table-column v-if="sortableSetting.skuName" :label="$t('BusinessPurchaseDetailPage.table.Description')" prop="skuName" align="center" width="150" />
          <el-table-column v-if="sortableSetting.length" :label="$t('BusinessPurchaseDetailPage.table.length')" prop="length" align="center"
            width="140">
            <template v-slot="{ row }">
              {{ row.length }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.width" :label="$t('BusinessPurchaseDetailPage.table.width')" prop="width" align="center"
            width="140">
            <template v-slot="{ row }">
              {{ row.width }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.height" :label="$t('BusinessPurchaseDetailPage.table.high')" prop="height" align="center"
            width="140">
            <template v-slot="{ row }">
              {{ row.height }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.weight" :label="$t('BusinessPurchaseDetailPage.table.Weight')" prop="weight" align="center"
            width="120">
            <template v-slot="{ row }">
              {{ row.weight }} kg
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.volume" :label="$t('BusinessPurchaseDetailPage.table.Volume')" prop="volume" align="center"
            width="160">
            <template v-slot="{ row }">
              {{ (row.width * row.height * row.length / 1000000) }} m³
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.qty" :label="$t('BusinessPurchaseDetailPage.table.per')+' (v)'" prop="qty" align="center" width="120" />
          <el-table-column v-if="sortableSetting.cartonLength" :label="$t('BusinessPurchaseDetailPage.table.boxLength')" prop="cartonLength" align="center" width="110">
            <template v-slot="{ row }">
              {{ row.cartonLength }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonWidth" :label="$t('BusinessPurchaseDetailPage.table.boxWidth')" prop="cartonWidth" align="center" width="100">
            <template v-slot="{ row }">
              {{ row.cartonWidth }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonHeight" :label="$t('BusinessPurchaseDetailPage.table.boxheight')" prop="cartonHeight" align="center" width="100">
            <template v-slot="{ row }">
              {{ row.cartonHeight }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonWeight" :label="$t('BusinessPurchaseDetailPage.table.boxWeight')" prop="cartonWeight" align="center" width="100">
            <template v-slot="{ row }">
              {{ row.cartonWeight }} kg
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonVolume" :label="$t('BusinessPurchaseDetailPage.table.boxVolume')+' (w)'" prop="cartonVolume" align="center" width="120">
            <template v-slot="{ row }">
              {{ (row.cartonLength * row.cartonWidth * row.cartonHeight / 1000000) }} m³
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.createdName" :label="$t('BusinessPurchaseDetailPage.table.Buyer')" prop="createdName" align="center" width="110">
          </el-table-column>
          <el-table-column prop="" :label="$t('table.operationText')" fixed="right" align="center" width="110">
            <template slot-scope="{ row, $index }">
              <el-button @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt20 flex flex-spacebetween">
          <span></span>
          <div class="font16" style="color: #3d3d3d">
            <span class="mr20">{{ $t('BusinessPurchaseDetailPage.plantQtySum') }}：<span class="font18">{{ planQtyTotal || 0 }}</span></span>
            <span class="mr20">{{ $t('BusinessPurchaseDetailPage.productVolume') }}：<span class="font18">{{ volumeTotal || 0 }} m³</span></span>
            <span>{{ $t('BusinessPurchaseDetailPage.cartonWeight') }}：<span class="font18">{{ weightTotal }} kg</span></span>
          </div>
        </div>
      </div>
    </div>
    <!--    表格setting-->
    <ElementTableSortable ref="ElementTableSortable" :page-type="sortableSettingPage" :sortable-setting="sortableSetting" @settingTableTitle="settingTableTitle" />
    <BjDialogList ref="dialogList" multiple :config="$BjDialogListConfig.skuDefault()" @confirm="onAddDialogConfirm" />
    <!-- EXCEL导入 -->
    <ExcelImportDialog ref="ExcelImport" :template-type="computedTemplateType" @submit="getTableData" />

  </el-form>
</template>
<script>
import ElementTableSortable from './PurchaseTableSortable';
import ExcelImportDialog from './ExcelImportDialog.vue';
import { purchaseApi } from '@/api';
import { maxToFixed } from '@/utils';
import { purchaseDefaultSearch } from '@/utils/BjDialogListConfig';
import viewMiXin from '@/utils/view-mixin.js';
import { STATUS_YES_NUM, PURCHASE_TYPE } from '@/utils/constants';
import BjInputNumber from '@/packages/BjInputNumber';
import BjInputMoney from '@/packages/BjInputMoney';
import moment from 'moment';
import RightToolbar from './RightToolbar';
const defaultForm = () => {
  return {
    expectedDate: moment().add(3, 'months').format('YYYY-MM-DD HH:mm:ss'),
    documentDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    requiredDate: moment().add(2, 'months').format('YYYY-MM-DD HH:mm:ss'),
    postingDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    goodsList: [],
    supplierCode: null,
    supplierName: null,
    purchaseCode: null,
    warehouseCode: null,
    warehouseName: null,
    purchaseType: 'COMMON',
    countryCode: 'Australia',
    deptAbbr: null,
    isFill: null,
    remarks: null
  };
};
export default {
  name: 'PurchaseViewForm',
  components: { BjInputMoney, BjInputNumber, ExcelImportDialog, RightToolbar, ElementTableSortable },
  mixins: [viewMiXin],
  props: {
    completeName: {
      type: String,
      default: 'BusinessPurchaseOrderIndex',
    },
    isCopy: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      STATUS_YES_NUM,
      PURCHASE_TYPE,
      colSpan: 6,
      form: defaultForm(),
      selection: [],
      index: null,
      exchangeRate: {
        cny: 1,
        aud: 4.671040,
        usd: 7.286098
      },
      options: [
        {value: 'p1', label: 'p1'},
        {value: 'p2', label: 'p2'}
      ],
      sortableSetting: {
        auPurchasePrice: true,
        linkUrl: true,
        consumptionTax: true,
        platformPrice: true,
        taxCode: true,
        refundResendPrice: true,
        seaInlandFreight: true,
        ebayPaypalPrice: true,
        estimatedProfit: true,
        estimatedProfitRate: true,
        requiredDate: true,
        barCode: true,
        brandName: true,
        categoryName: true,
        skuName: true,
        length: true,
        width: true,
        height: true,
        weight: true,
        volume: true,
        qty: true,
        cartonLength: true,
        cartonWidth: true,
        cartonHeight: true,
        cartonWeight: true,
        cartonVolume: true,
        createdName: true,
      },
      sortableSettingPage: 'PurchaseApplyAdd',
      tableShow: true
    };
  },
  computed: {
    weightTotal() {
      if (!this.form.goodsList.length) return 0;
      return this.form.goodsList.reduce((pre, cur) => (pre += cur.cartonWeight), 0);
    },
    volumeTotal() {
      if (!this.form.goodsList.length) return 0;
      const volumeTotal = this.form.goodsList.reduce((pre, cur) => {
        const number = Math.ceil(cur.planQty / cur.qty);
        // eslint-disable-next-line no-return-assign
        return pre += (number * (cur.length * cur.width * cur.height));
      }, 0);
      return volumeTotal / 1000000;
    },
    planQtyTotal() {
      if (!this.form.goodsList.length) return 0;
      return this.form.goodsList.reduce((pre, cur) => (pre += cur.planQty), 0);
    },
    platformPriceHead() {
      return `h = e * 0.12`;
    },
    seaAndInlandFreightHead() {
      return `o = { [(k * ${(this.exchangeRate.aud / this.exchangeRate.usd).toFixed(2)}) + (l / ${(this.exchangeRate.aud).toFixed(2)}) + m] / n } * w / v`;
    },
    ebayAndPaypalHead() {
      return `p = e * 0.12 + 0.3`;
    },
    estimatedProfitHead() {
      return `q = e - d - p - f - g - o`;
    },
    resendRefundRateHead() {
      if (this.form.purchaseType === 'COMMON') {
        return `j = e * 0.05`;
      } else {
        return `j = e * 0.03`;
      }
    },
    consumptionTaxHead() {
      if (this.form.purchaseType === 'COMMON') {
        return `g = e / 11`;
      } else {
        return `g = e * 0.1`;
      }
    },
    computedTemplateType() {
      return this.form.purchaseType;
    },
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.countryCode || !this.form.recipientProvinceCode) {
            callback(new Error(this.$t('WarehouseManagement.form.Please')));
          }
          callback();
        });
      };
      return {
        type: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.storageTypeText'), trigger: 'change' }],
        // warehouseCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        // supplierCode: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.supplierCodeText'), trigger: 'change' }],
        paymentType: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.paymentTypeText'), trigger: 'blur' }],
        expectedDate: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.expectedDateText'), trigger: 'blur' }],
        requiredDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        documentDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        planQty: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.planQtyText'), trigger: 'blur' }],
        taxUnitPrice: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.taxUnitPriceText'), trigger: 'blur' }],
        taxRate: [{ required: true, message: this.$t('BusinessPurchaseComponentsPur.table.taxRateText'), trigger: 'blur' }],
        fullAddress: { required: true, validator: validateFullAddress, trigger: 'change' },
        recipientCity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        recipientDistrict: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        recipientAddress: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        postcode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
    dialogConfig() {
      purchaseDefaultSearch[0].disabled = true;
      purchaseDefaultSearch[1].disabled = true;
      return this.$BjDialogListConfig['purchaseGoodsDefault'](
        this.$t('BusinessPurchaseComponentsPur.dialogText'),
        {
          search: purchaseDefaultSearch,
          defaultQuery: {
            supplierName: this.form.supplierName,
            supplierCode: this.form.supplierCode,
          },
        },
      );
    },
    isList() {
      return this.list.length > 0;
    },
  },
  watch: {
    'form.goodsList': {
      deep: true,
      immediate: false,
      handler: function (newVal, oldVal) {
        for (let i = 0; i < newVal.length; i++) {
          const item = newVal[i];
          // 澳币采购价
          const updateAuPurchasePrice = (newVal, oldVal) => {
            const cnPurchasePrice = newVal;
            const auPurchasePrice = Number((cnPurchasePrice * 1.02 / this.exchangeRate['aud']).toFixed(2));
            this.form.goodsList[i].auPurchasePrice = auPurchasePrice;
          };
          this.$watch(
            () => item.cnPurchasePrice,
            updateAuPurchasePrice
          );
          // 消费税
          const updateConsumptionTax = (newVal, oldVal) => {
            const price = newVal;
            let consumptionTax = 0;
            let refundResendPrice = 0;
            if (this.form.purchaseType === 'COMMON') {
              consumptionTax = Number((price / 11).toFixed(2));
              refundResendPrice = Number((price * 0.05).toFixed(2));
            } else {
              consumptionTax = Number((price * 0.1).toFixed(2));
              refundResendPrice = Number((price * 0.03).toFixed(2));
            }
            this.form.goodsList[i].consumptionTax = consumptionTax;
            this.form.goodsList[i].refundResendPrice = refundResendPrice;
            this.form.goodsList[i].platformPrice = Number((price * 0.12).toFixed(2));
            this.form.goodsList[i].ebayPaypalPrice = Number((price * 0.12 + 0.3).toFixed(2));
          };
          this.$watch(
            () => item.price,
            updateConsumptionTax
          );

          // 海运与陆运运费
          const { cartonLength, cartonWidth, cartonHeight, qty, cabinetVolume, handlePrice, cnyFreight, usdFreight} = item;
          const volume = cartonLength * cartonWidth * cartonHeight / 1000000;
          // 澳币汇率/美币汇率
          const audAndUsdexchangeRate = this.exchangeRate.aud / this.exchangeRate.usd;
          const computer = (Number(usdFreight) * audAndUsdexchangeRate) + (Number(cnyFreight) / this.exchangeRate.aud) + Number(handlePrice);
          const result = (computer / cabinetVolume) * volume / qty;
          item['seaInlandFreight'] = Number(result).toFixed(4);
          // 预计利润
          const { price, auPurchasePrice, consumptionTax, expressPrice, seaInlandFreight} = item;
          item['estimatedProfit'] = Number(price - auPurchasePrice - consumptionTax - (price * 0.12 + 0.3) - expressPrice - seaInlandFreight).toFixed(2);
          // 预计利润率
          item['estimatedProfitRate'] = (item['estimatedProfit'] / price * 100).toFixed(2);
        }
      }
    },
    'form.purchaseType': {
      immediate: true,
      handler(val) {
        if (val === 'COMMON') {
          // eslint-disable-next-line no-return-assign
          this.form.goodsList.forEach(item => item['taxCode'] = 'p2');
        } else {
          // eslint-disable-next-line no-return-assign
          this.form.goodsList.forEach(item => item['taxCode'] = 'p1');
        }
      }
    }
  },
  created() {
    this.getExchangeRate();
    if (localStorage.getItem('purchaseTableTitleSetting')) {
      this.sortableSetting = JSON.parse(localStorage.getItem('purchaseTableTitleSetting'));
    }
  },
  mounted() {
    const forcaseData = this.$store.getters.forecaseData;
    if (forcaseData.length > 0 && this.$route.query?.source === 'forecast') {
      if (process.env.NODE_ENV === 'development') console.log('forcaseData:偶现bug:', forcaseData);
      this.form.goodsList = forcaseData;
      this.form.goodsList.forEach(item => {
        item.createdName = this.$store.getters.name;
        this.$set(item, 'price', '');
        this.$set(item, 'cabinetVolume', 68);
        this.$set(item, 'taxCode', this.form.purchaseType === 'COMMON' ? 'p2' : 'p1');
        this.$set(item, 'usdFreight', 0);
        this.$set(item, 'cnyFreight', 4500);
        this.$set(item, 'handlePrice', 1800);
        this.$set(item, 'requiredDate', moment().format('YYYY-MM-DD HH:mm:ss'));
      });
    }

    this.form.buyerName = this.$store.getters.name;
    this.form.deptAbbr = this.$store.getters.deptAbbr;
    if (this.isEdit || this.isCopy) this.getData();
    if (this.isList) {
      this.getToPurchaseGoods();
    }
  },
  methods: {
    settingTableTitle(value) {
      localStorage.setItem('purchaseTableTitleSetting', JSON.stringify(value));
      this.tableShow = false;
      this.sortableSetting = value;
      setTimeout(() => (this.tableShow = true), 500);
    },
    toolbarShow() {
     this.$nextTick(() => {
       this.$refs.ElementTableSortable.show();
     });
    },
    // 获取实时汇率
    getExchangeRate() {
      purchaseApi.getExchangeRate().then(res => {
        this.exchangeRate.cny = res.cny;
        this.exchangeRate.aud = res.aud;
        this.exchangeRate.usd = res.usd;
      });
    },
    changeLov() {
      // this.form.goodsList = [];
    },
    getTableData(item) {
      this.form.goodsList = item;
      this.form.goodsList.forEach(item => {
        this.$set(item, 'taxCode', 'p2');
        this.$set(item, 'usdFreight', 0);
        this.$set(item, 'cnyFreight', 4500);
        this.$set(item, 'handlePrice', 1800);
        this.$set(item, 'requiredDate', moment().format('YYYY-MM-DD HH:mm:ss'));
        this.$set(item, 'cabinetVolume', 68);
        this.$set(item, 'createdName', this.form.buyerName);
      });
    },
    onImport() {
      this.$refs.ExcelImport.show();
    },
    onChangeSupplier(v, item) {
      this.form.supplierName = item.name;

      if (this.isList) {
        this.getSupplierData(v);
      }
    },
    onChangeWarehouse(v, item) {
      this.form.warehouseName = item.name;
      this.form.warehouseCode = item.code;
    },
    onChangeLogisticsBusiness(v, item) {
      this.form.ogisticsBusinessCode = item?.code;
      this.form.logisticsBusinessName = item?.name;
    },
    onAdd() {
      this.$refs.dialogList.show();
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          row
            ? this.form.goodsList.splice(index, 1)
            : (this.form.goodsList = this.form.goodsList.filter(
              row => !this.selection.map(e => e.skuCode).includes(row.skuCode),
            ));
        })
        .catch(() => { });
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    // 添加采购单、商品回调相关
    onAddDialogConfirm(data) {
      if (this.form.goodsList.length > 0) {
        const newData = data;
        const oldData = this.form.goodsList;
        const differentItems = this.$lodash.differenceBy(newData, oldData, 'skuCode');
        if (differentItems.length) {
          differentItems.forEach(item => {
          if (this.form.purchaseType === 'COMMON') {
            this.$set(item, 'taxCode', 'p2');
          } else {
            this.$set(item, 'taxCode', 'p1');
          }
          if (!item.cartonHeight || !item.cartonLength || !item.cartonWeight) {
            item['cartonHeight'] = item.height;
            item['cartonLength'] = item.length;
            item['cartonWidth'] = item.width;
          }
          item['cartonWeight'] = item.cartonWeight || 0;
          item['qty'] = item.qty || 1;
          this.$set(item, 'usdFreight', 0);
          this.$set(item, 'cnyFreight', 4500);
          this.$set(item, 'handlePrice', 1800);
          this.$set(item, 'requiredDate', moment().format('YYYY-MM-DD HH:mm:ss'));
          this.$set(item, 'cabinetVolume', 68);
          this.$set(item, 'createdName', this.form.buyerName);
        });
        }
        this.form.goodsList = [...oldData, ...differentItems];
      } else {
        this.form.goodsList = data;
        this.form.goodsList.forEach(item => {
        if (this.form.purchaseType === 'COMMON') {
            this.$set(item, 'taxCode', 'p2');
          } else {
            this.$set(item, 'taxCode', 'p1');
          }
          if (!item.cartonHeight || !item.cartonLength || !item.cartonWeight) {
            item['cartonHeight'] = item.height;
            item['cartonLength'] = item.length;
            item['cartonWidth'] = item.width;
          }
          item['cartonWeight'] = item.cartonWeight || 0;
          item['qty'] = item.qty || 1;
          this.$set(item, 'usdFreight', 0);
          this.$set(item, 'cnyFreight', 4500);
          this.$set(item, 'handlePrice', 1800);
          this.$set(item, 'requiredDate', moment().format('YYYY-MM-DD HH:mm:ss'));
          this.$set(item, 'cabinetVolume', 68);
          this.$set(item, 'createdName', this.form.buyerName);
      });
      }
    },
    handleClose() {
      this.$store.commit('business/movePurchasForecast');
      this.cancel();
    },
    handleConfirm() {
      const msg = {
        planQty: `${this.$t('BusinessPurchaseApplyDetail.orderQty')}${this.$t('emptyWarningText')}`,
        cnPurchasePrice: `${this.$t('BusinessPurchaseApply.cnPurchasePrice')}${this.$t('emptyWarningText')}`,
        price: `${this.$t('BusinessPurchaseApply.price')}${this.$t('emptyWarningText')}`,
        expressPrice: `${this.$t('BusinessPurchaseDetailPage.table.Express')}${this.$t('emptyWarningText')}`,
        linkMinPrice: `${this.$t('BusinessPurchaseDetailPage.table.Price')}${this.$t('emptyWarningText')}`
      };
      let bStop = true;
      let msgError = '';
      Object.keys(msg).forEach(item => {
        this.form.goodsList.forEach(jitem => {
          if (!jitem[item]) {
            bStop = false;
            msgError = msg[item];
          }
        });
      });
      if (!bStop) {
        this.msgError(msgError);
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.goodsList.length === 0) {
            this.msgError(this.$t('BusinessPurchaseComponentsPur.msgError'));
            return;
          }
          for (const item of Object.values(this.form.goodsList)) {
            if (isNaN(item.seaInlandFreight)) {
              this.msgError(this.$t('海运与内陆运费计算有误，请检查与之相关的数值是否正确！'));
              return;
            }
            if (isNaN(item.estimatedProfit)) {
              this.msgError(this.$t('预计利润计算有误，请检查与之相关的数值是否填写正确！'));
              return;
            }
          }
          this.sendData();
        } else {
          return false;
        }
      });
    },
    sendData() {
      let API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA = {
          objectVersionNumber: API_DATA.objectVersionNumber,
          id: API_DATA.id,
          supplierCode: API_DATA.supplierCode,
          supplierName: API_DATA.supplierName,
          expectedDate: API_DATA.expectedDate,
          documentDate: API_DATA.documentDate,
          requiredDate: API_DATA.requiredDate,
          postingDate: API_DATA.postingDate,
          warehouseName: API_DATA.warehouseName,
          warehouseCode: API_DATA.warehouseCode,
          deptAbbr: API_DATA.deptAbbr,
          countryCode: API_DATA.countryCode,
          isFill: API_DATA.isFill,
          purchaseType: API_DATA.purchaseType,
          goodsList: API_DATA.goodsList,
          remarks: API_DATA.remarks
        };
      } else if (this.isCopy) {
        API_DATA.goodsList.forEach(item => delete item.id);
        API_DATA = {
          supplierCode: API_DATA.supplierCode,
          supplierName: API_DATA.supplierName,
          expectedDate: API_DATA.expectedDate,
          documentDate: API_DATA.documentDate,
          requiredDate: API_DATA.requiredDate,
          postingDate: API_DATA.postingDate,
          isFill: API_DATA.isFill,
          warehouseName: API_DATA.warehouseName,
          warehouseCode: API_DATA.warehouseCode,
          deptAbbr: API_DATA.deptAbbr,
          countryCode: API_DATA.countryCode,
          purchaseType: API_DATA.purchaseType,
          goodsList: API_DATA.goodsList,
          remarks: API_DATA.remarks
        };
      } else {
        API_DATA.goodsList = API_DATA.goodsList.map(row => {
          return {
            alreadyQty: 0,
            auPurchasePrice: row.auPurchasePrice,
            cnPurchasePrice: row.cnPurchasePrice,
            consumptionTax: row.consumptionTax,
            estimatedProfit: row.estimatedProfit,
            estimatedProfitRate: row.estimatedProfitRate || 0,
            expressPrice: row.expressPrice,
            linkMinPrice: row.linkMinPrice,
            linkUrl: row.linkUrl,
            planQty: row.planQty,
            platformPrice: row.platformPrice,
            price: row.price,
            skuCode: row.skuCode,
            skuName: row.skuName,
            spuCode: row.spuCode,
            spuName: row.spuName,
            spuPic: row.spuPic,
            standardProfitRate: row.standardProfitRate,
            waitQty: 0,
            ebayPaypalPrice: row.ebayPaypalPrice,
            refundResendPrice: row.refundResendPrice,
            usdFreight: row.usdFreight,
            cnyFreight: row.cnyFreight,
            handlePrice: row.handlePrice,
            seaInlandFreight: row.seaInlandFreight,
            cabinetVolume: row.cabinetVolume,
            taxCode: row.taxCode,
            requiredDate: row.requiredDate
          };
        });
      }
      const apiName = (this.isEdit ? 'put' : 'add') + 'Applys';
      this.sendApi(apiName, API_DATA);
    },
    sendApi(apiName, API_DATA) {
      purchaseApi[apiName](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$store.commit('business/movePurchasForecast');
            if (this.isEdit) {
              this.$router.go(-1);
            } else {
              this.$router.push({ name: 'BusinessPurchaseApply' });
            }
            this.form = defaultForm();
          }, 200);
        }
      });
    },
    getData() {
      purchaseApi['getApplysDetail']({
        id: this.$route.query.id,
        code: this.$route.query.code,
      }).then(async res => {
        if (!res?.goodsList) return;
        const skuCode = res.goodsList.map(item => item.skuCode);
        const skuList = await purchaseApi.purchaseGoodsImport(skuCode);
        if (!skuList.length) return;
        const goodsList = [];
        skuList.forEach(v1 => {
          res.goodsList.forEach(v2 => {
            if (v2.skuCode === v1.skuCode) {
              if (!v1.cartonHeight || !v1.cartonLength || !v1.cartonWidth) {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    cartonHeight: v1.height,
                    cartonLength: v1.length,
                    cartonWidth: v1.width,
                    cartonWeight: v1.cartonWeight || 0,
                    qty: v1.qty || 1,
                    createdName: res.createdName,
                    categoryName: v1.categoryStr
                  });
              } else {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    qty: v1.qty || 1,
                    cartonWeight: v1.cartonWeight || 0,
                    createdName: res.createdName,
                    categoryName: v1.categoryStr
                  });
              }
            }
          });
        });
        this.form = res;
        this.form.goodsList = goodsList;
      });
    },
    // 获取商品信息（数据需要调用两个接口然后整合数据）
    async getToPurchaseGoods() {
      const ids = this.list.map(row => {
        return {
          id: row.id,
          objectVersionNumber: row.objectVersionNumber,
        };
      });
      const res1 = await purchaseApi['getToPurchaseGoods']({ ids });
      const skuList = res1.map(row => row.skuCode).join();
      const { content } = await purchaseApi['getSupplierGoodss']({ skuCodeList: skuList });
      const goodsList = res1.map(row => {
        const data = content.find(e => e.skuCode === row.skuCode);
        return {
          ...data,
          ...row,
          planQty: row.waitQty,
          remarks: null,
          taxPrice: maxToFixed(row.planQty * data.taxUnitPrice, 5),
        };
      });
      this.form.goodsList = goodsList;
      const index = Math.floor(Math.random() * this.list.length);
      const { warehouseCode, warehouseName } = this.list[index];
      this.form.supplierCode = goodsList[index].supplierCode;
      this.form.supplierName = goodsList[index].supplierName;
      this.form.warehouseCode = warehouseCode;
      this.form.warehouseName = warehouseName;
    },
    getSupplierData(supplierCode) {
      const skuCodeList = this.form.goodsList.map(row => row.skuCode).join();
      purchaseApi['getSupplierGoodss']({ supplierCode, skuCodeList, size: 9999 }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.form.goodsList = this.form.goodsList.map(row => {
            const data = res.content.find(e => e.skuCode === row.skuCode);
            return {
              ...row,
              taxUnitPrice: data ? data.taxUnitPrice : undefined,
              taxRate: data ? data.taxRate : undefined,
              taxPrice: data ? maxToFixed(row.planQty * data.taxUnitPrice, 5) : undefined,
              supplierSpuCode: data ? data.supplierSpuCode : undefined,
              supplierSkuCode: data ? data.supplierSkuCode : undefined,
            };
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-table .warning-row {
  color: red !important;
}
.font18 {
  font-size: 18px;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.red {
  background-color: red;
}

.yellow {
  background-color: yellow;
}

.green {
  background-color: green;
}
</style>
